import React, { memo } from 'react'
import { pick, isEqual } from 'libraries/lodash'
import connect from 'front-end-core/decorators/connect'
import { getGraphStats, getGroupedStats } from 'services/DealwatchService'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import GraphChart from 'pages/mwanalytics/GraphChart'
import LocationMap from 'pages/mwanalytics/LocationMap'
import { useSelector } from 'react-redux'
import selectAolName from 'redux/selectors/selectAolName'
import Skeleton from '@material-ui/lab/Skeleton'
import Grid from '@material-ui/core/Grid'

const getParams = props => pick(props, ['parameterName', 'interval', 'groupBy', 'stats'])

const areEqual = (prevProps, nextProps) => {
  const prevParams = getParams(prevProps)
  const nextParams = getParams(nextProps)
  return isEqual(prevParams, nextParams)
}

const Plot = memo(props => {
  const display = props.display || 'graph'
  const aol = useSelector(selectAolName)

  return (
    <div className='pa6 h-100 bg-white'>
      {display === 'graph' ? <GraphChart {...{ ...props, aol }} /> : <LocationMap {...props} />}
    </div>
  )
}, areEqual)

export const PlotSkeleton = () => (
  <div className='pa6 bg-white'>
    <Skeleton variant='text' width={300} className='mb6' />
    <Skeleton variant='rect' height={300} className='mh8 mb6' />
    <Grid container spacing={1}>
      {[...Array(6).keys()].map(val => (
        <Grid item xs={6} key={val}>
          <Skeleton variant='text' width={100} />
        </Grid>
      ))}
    </Grid>
  </div>
)

export default connect(({
  parameterName,
  groupBy,
  interval,
  plot,
  normalize,
  tickFormat = '',
  displayName,
  reorder
}) => {
  const factor = !normalize && tickFormat.indexOf('%') > -1 ? 0.01 : 1
  const parameters = {
    parameterName,
    groupBy,
    interval,
    plot,
    normalize,
    factor,
    displayName,
    reorder
  }

  return {
    stats: groupBy
      ? getGroupedStats({ ...parameters })
      : getGraphStats({ ...parameters })
  }
})(props => (
  <ResponseConsumer
    content={() => <Plot {...props} />} response={props.stats}
    pendingComponent={PlotSkeleton}
  />
))
